"use client";

/** 점수 → HSL 색상 (tier 기반) */
function getTierColor(score: number): string {
  if (score >= 80) return "hsl(142, 76%, 36%)";
  if (score >= 60) return "hsl(221, 83%, 53%)";
  if (score >= 40) return "hsl(38, 92%, 50%)";
  return "hsl(0, 84%, 60%)";
}

/** 점수 → CSS 변수 색상 (하위 호환) */
function getScoreColor(score: number): string {
  return getTierColor(score);
}

/** 점수 → 등급 라벨 */
function getScoreLabel(score: number): string {
  if (score >= 80) return "매우 우수";
  if (score >= 60) return "우수";
  if (score >= 40) return "보통";
  if (score >= 20) return "주의";
  return "위험";
}

/** 점수 → Badge variant */
function getScoreBadgeVariant(score: number): "success" | "info" | "warning" | "danger" {
  if (score >= 80) return "success";
  if (score >= 60) return "info";
  if (score >= 40) return "warning";
  return "danger";
}

/** 점수 → 배경 그라디언트 (하위 호환) */
function getScoreBg(score: number): string {
  if (score >= 80) return "linear-gradient(135deg, rgba(66,165,245,0.06) 0%, rgba(66,165,245,0.02) 100%)";
  if (score >= 60) return "linear-gradient(135deg, rgba(102,187,106,0.06) 0%, rgba(102,187,106,0.02) 100%)";
  if (score >= 40) return "linear-gradient(135deg, rgba(253,216,53,0.06) 0%, rgba(253,216,53,0.02) 100%)";
  if (score >= 20) return "linear-gradient(135deg, rgba(255,167,38,0.06) 0%, rgba(255,167,38,0.02) 100%)";
  return "linear-gradient(135deg, rgba(239,83,80,0.06) 0%, rgba(239,83,80,0.02) 100%)";
}

export { getScoreColor, getScoreLabel, getScoreBg, getTierColor, getScoreBadgeVariant };

interface ScoreRingProps {
  score: number;
  size?: number;
  strokeWidth?: number;
  label?: string;
}

/**
 * ScoreRing — 하위 호환용 (사용하지 않는 곳이 있을 수 있으므로 유지)
 */
export function ScoreRing({ score, label }: ScoreRingProps) {
  const color = getTierColor(score);
  const pct = Math.min(Math.max(score, 0), 100);

  return (
    <div className="flex flex-col items-center text-center rounded-lg px-4 py-5 bg-card border">
      <span className="text-2xl font-bold leading-none tabular-nums" style={{ color }}>
        {score}
      </span>
      <div className="w-full h-[3px] rounded-full bg-muted mt-3">
        <div
          className="h-full rounded-full transition-all duration-700 ease-out"
          style={{ width: `${pct}%`, backgroundColor: color }}
        />
      </div>
      {label && (
        <span className="mt-2 text-xs text-muted-foreground leading-tight">{label}</span>
      )}
    </div>
  );
}
